/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();


/*  ==========================================================================
    GENERAL - resizing iframe to fit content
    ========================================================================== */

// const resizeIframe = function (obj) {
//   // console.log(obj.contentWindow);
//   obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + "px";
// };

  // let eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
  // let eventer = window[eventMethod];
  // let messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
  
  // eventer(
  //   messageEvent,
  //   function (e) {
  //    let message = e.data;

  //    console.log(e);
  //     document.getElementById("formid--" + message.id).style.height = message.height + "px";
  //   },
  //   false
  // );

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
      Audio Player
    ========================================================================== */

  let audioplayer = false;

  const audioPlyrInit = function () {
    const plyr = document.querySelector(".podcast__plyr");

    if (!plyr) {
      return;
    }

    const controls = `
      <div class="plyr__controls">
          <button type="button" class="plyr__control plyr__control--rewind" data-plyr="rewind">
              <span class="fal fa-backward-fast"></span>
          </button>
          <button type="button" class="plyr__control plyr__control--play" aria-label="Play, {title}" data-plyr="play">
              <span class="icon--not-pressed fas fa-play"></span>
              <span class="icon--pressed fas fa-pause"></span>
          </button>
          <button type="button" class="plyr__control plyr__control--forward" data-plyr="fast-forward">
              <span class="fal fa-forward-fast"></span>
          </button>
          <div class="player__times">
            <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
            <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>   
          </div>
          <div class="plyr__progress__container">
            <div class="plyr__progress">
                <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
            </div>
          </div>
      </div>
      `;


    let podcastPlyr = new Plyr(plyr, { controls });

  }; 

  audioPlyrInit();

/*  ==========================================================================
    GENERAL - Itinerary / Programme Accordion
    ========================================================================== */

const programmeQuestions = document.querySelectorAll(".programme__question");

const programmeAccordionInit = function (programmeAccordionItems) {
  if (!programmeAccordionItems) {
    return;
  }

  programmeAccordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.classList.toggle("active");
      item.nextElementSibling.classList.toggle("active");
    })
  );
}; // accordionInit();
programmeAccordionInit(programmeQuestions);


/*  ==========================================================================
    FAKE load more on single event
    ========================================================================== */
const eventLoadmoreBtn = document.querySelector(".showhidden__loadmore"),
  eventContainer = document.querySelector(".related-events__container");

if (eventLoadmoreBtn && eventContainer) {
  eventLoadmoreBtn.addEventListener("click", function () {
    const events = eventContainer.querySelectorAll(".event");

    let requests = [...events].map(item => {
      return new Promise(resolve => {
        item.style.display = "block";
        item.classList.add("effect", "effect--default");
        // console.log("done with", item);
        resolve("Success!");
      });
    });

    Promise.all(requests).then(() => {
      eventLoadmoreBtn.style.display = "none";
      effectsInit();
    });
  });
}

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelectorAll(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;

  let data = {};
  let isCustomQuery = false;
  let loadmoreContainerCustom = "";

  if (this.dataset && this.dataset.customQuery) {
    let customQueryArgs = window[this.dataset.customQuery];
    loadmoreContainerCustom = document.querySelector(".loadmore-" + button.dataset.customQuery);
    isCustomQuery = true;
    data = {
      action: "loadmore",
      query: customQueryArgs.posts, // that's how we get params from wp_localize_script() function
      page: customQueryArgs.current_page,
      iseventrow: button.dataset.event && button.dataset.event === "row" ? true : false
    };
  } else {
    data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page,
      iseventrow: button.dataset.event && button.dataset.event === "row" ? true : false
    };
  }

  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        if (isCustomQuery) {
          let customQueryArgs = window[button.dataset.customQuery];
          loadmoreContainerCustom.innerHTML = loadmoreContainerCustom.innerHTML + data;
          customQueryArgs.current_page++;
          // if last page, remove the button..
          if (parseInt(customQueryArgs.current_page) === parseInt(customQueryArgs.max_page)) {
            button.remove();
          }
        } else {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
        }

        let showingCounter = loadmoreContainer.childElementCount;
        const countResultsBar = document.querySelector(".posts__searchresult");
        if (countResultsBar) {
          countResultsBar.innerText = `Showing ${showingCounter} ${showingCounter === 1 ? "result" : "results"}`;
        }

        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.forEach(el => el.addEventListener("click", loadmoreLoadPosts));
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effectsInit = function () {

  const effects = document.querySelectorAll(".effect");

  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit();


/*  ==========================================================================
    Rellax: Parallax Effects
    ========================================================================== */

  if ($(".rellax") && $(".rellax").length > 0){
    var rellax = new Rellax(".rellax", {
      center: true,
      round: true,
      vertical: true,
      horizontal: false,
      breakpoints: [576, 768, 1201]
    });
  }

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).on("initialized.owl.carousel", function () {
      // on init run our multi slide adaptive height function
      if (this.classList.contains("carousel--autoheight")) {
        multiSlideAdaptiveHeight(this);
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // run our multi slide adaptive height function incase current slider active slides change height responsively
      if (elem.classList.contains("carousel--autoheight")) {
        multiSlideAdaptiveHeight(elem);
      }
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    $(elem).on("changed.owl.carousel", function (event) {
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

   
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

// our multi slide adaptive height function passing slider object
function multiSlideAdaptiveHeight(slider) {
  // set our vars
  let slideHeights = [];
  let tallestSlide = 0;

  // very short delay in order for us get the correct active slides
  setTimeout(function () {
    // loop through each active slide for our current slider
    let carouselSlides = slider.querySelectorAll(".owl-item");
    carouselSlides.forEach(item => {
     
      if (item.querySelector(".tile__wrapper")) {
        // add current active slide height to our active slides array
        slideHeights.push(item.querySelector(".tile__wrapper").clientHeight);
      }
    });

    // for each of the active slides heights
    slideHeights.forEach(item => {
      // if current active slide height is greater than tallest slide height
      if (item > tallestSlide) {
        // override tallest slide height to current active slide height
        tallestSlide = item;
      }
    });

    carouselSlides.forEach(item => {
      item.querySelector(".col").style.height = tallestSlide + "px";
    });

    // set the current slider slick list height to current active tallest slide height
    slider.style.height = tallestSlide + "px";
  }, 500);
}

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

  let default_animation_speed = 1;

  let el_class = "marquee__tile";
  let inner_class = "marquee__wrap";

  const marquee__init = function (marquee) {
    // Setup two scroll wraps (duplicate the HTML)
    const wrapper = document.createElement("div");

    wrapper.classList.add(inner_class);

    marquee.querySelectorAll("." + el_class).forEach(el => {
      el.parentNode.insertBefore(wrapper, el);

      wrapper.appendChild(el);
    });

    marquee.appendChild(wrapper.cloneNode(true));
    marquee.appendChild(wrapper.cloneNode(true));
    marquee.appendChild(wrapper.cloneNode(true));
    marquee.appendChild(wrapper.cloneNode(true));

    // Setup animation times
    marquee__resize(marquee);

    // Once everything is set up, add "loaded" class
    marquee.classList.add("marquee--loaded");

    lazyLoadInstance.update(); // reinit lazy load after clones
  };

  const marquee__resize = function (marquee) {
    // // Check if element has custom speed or default
    let animation_speed = marquee.dataset.speed && marquee.dataset.speed !== "" ? marquee.dataset.speed : default_animation_speed;

    // Set animation time
    let linelength = marquee.parentNode.offsetWidth;

    let distance = linelength;
    let speed = animation_speed * 0.01;
    let duration = distance / speed;
    let delay = 0 - duration / 3;

    marquee.querySelectorAll("." + inner_class).forEach((el, index) => {
      el.style.animationDuration = duration + "ms";
      el.style.animationDelay = delay * index + "ms";
    });
  };

  document.querySelectorAll(".marquee").forEach(el => marquee__init(el));

  window.addEventListener("resize", function () {
    const marqueeTiles = document.querySelectorAll("." + el_class);
    if (marqueeTiles){ 
      marqueeTiles.forEach(el => marquee__resize(el));
    }
  });


/*  ==========================================================================
	NAVIGATION - Sitnav
	========================================================================== */

const sitenav = document.querySelector(".sitenav--left");
const sitenavDropdown = document.querySelector(".sitenav__dropdown");
const sitenavSections = sitenavDropdown.childNodes;

const overClass = "sitenav__item--over";
const navOpenBodyClass = "sitenavopen";
const activeSectionClass = "sitenavsection--active";

const siteHeader = document.querySelector(".siteheader");

let currentLi = false;
let dropdownCloseTimer = false;

let showDelay = 200;
let menuEnterTimer;

const clickedOusideSitenav = function (e) {
  if (!body.classList.contains(navOpenBodyClass)) {
    return;
  }
  let isClickInsideElement =
    sitenav.contains(e.target) ||
    sitenav === e.target ||
    (document.querySelector("." + activeSectionClass) && ( document.querySelector("." + activeSectionClass).contains(e.target) || document.querySelector("." + activeSectionClass) === e.target));

  if (!isClickInsideElement) {
    sitenavClose();
  }
}; // clickedOusideSearch();

const sitenavsectionOpen = function (targetLi) {
  
  const targetSectionClass = `sitenavsection--${targetLi.getAttribute("data-sitenavsection")}`;

  sitenavSections.forEach(section => {
    if (section.classList) {
      if (section.classList.contains(targetSectionClass)) {

        section.classList.add("sitenavsection--active");

        document.querySelectorAll(`.${overClass}`).forEach(item => item.classList.remove(overClass));

        targetLi.classList.add(overClass);
        body.classList.add(navOpenBodyClass);

        currentLi = targetLi;
      } else {
        section.classList.remove(activeSectionClass);
      }
    }
  });
};

const sitenavClose = function () {
  document.querySelectorAll(`.${overClass}`).forEach(item => item.classList.remove(overClass));
  // Set height to 0 and remove classes
  sitenavSections.forEach(section => {
    if (section.classList){ 
      section.classList.remove(activeSectionClass);
    }
  });
  body.classList.remove(navOpenBodyClass);
  if (currentLi) {
    currentLi.classList.remove(overClass);
  }

  body.removeEventListener("mouseup", clickedOusideSitenav, false);
};

const sitenavitemToggle = function (e) {
  // On click of sitenavitem open or close the dropdown
  e.preventDefault();
  const sitenavItem = e.target.closest(".sitenav__item");

  // If the dropdown is open then close the Dropdown and target section
  if (sitenavItem.classList.contains(overClass)) {
    sitenavClose();
  } else {
    sitenavsectionOpen(sitenavItem);
    body.addEventListener("mouseup", clickedOusideSitenav, false);
  }
};

const sitenavInit = function () {
  // Check if is touchscreen and setup dropdown to show on tap as well as hover
  if (isTouchDevice) {
    // IF TOUCHSCREEN (e.g. Ipad users)...
    // Setup dropdown to show on tap
    sitenav.addEventListener("click", function (e) {
      if (
        e.target.closest(".sitenav__item") &&
        e.target.closest(".sitenav__item").hasAttribute("data-sitenavsection")
      ) {
        e.preventDefault();

        if (e.target.closest(".sitenav__item").classList.contains(overClass)) {
          sitenavClose();
        } else {
          sitenavsectionOpen(e.target.closest(".sitenav__item"));
        }
      }
    });
  } else {
    // IF DESKTOP...

    sitenav.addEventListener("click", function (e) {
      if (
        e.target.closest(".sitenav__item") &&
        e.target.closest(".sitenav__item").hasAttribute("data-sitenavsection")
      ) {
        sitenavitemToggle(e);
      }
    });

  }
}; // sitenav__init()

sitenavInit();


/*  ==========================================================================
NAVIGATION - mobnav
========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();

    let mobnavHeight = 0;
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      mobnavSetHeight();
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      mobnav.style.height = 0;
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

// On resize check mobnav height is still right
const mobnavResize = function () {
  let mobnavHeight = 0;
  if (body.classList.contains(mobnavOpenclass)) {
    mobnavSetHeight();
  }
}; // mobnavResize()

window.addEventListener(
  "resize",
  function (event) {
    mobnavResize();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
    NAVIGATION - hide announcement banner on scroll 
    ========================================================================== */

const announcementBar = document.querySelector(".announcement"),
  announcementCloseBtn = document.querySelector(".announcement__close"),
  siteheader = document.querySelector(".siteheader:not(.siteheader--padder)");

const announcementBarHide = function(){
   if (window.scrollY > 50) {
     siteheader.classList.add("siteheader--hideannouncement");
     announcementBar.style.marginTop = `-${announcementBar.clientHeight}px`;
   } else {
     siteheader.classList.remove("siteheader--hideannouncement");
     announcementBar.style.marginTop = 0;
   }
};

const announcementBarInit = function () {

  // Get saved data from sessionStorage
  let closeannouncement = sessionStorage.getItem("key");

  if (closeannouncement) {
    siteheader.classList.add("siteheader--closeannouncement");
    return;
  }

  if (!announcementBar) {
    return;
  }

  document.addEventListener("scroll",  announcementBarHide);
  window.addEventListener("resize", announcementBarHide);

  announcementCloseBtn.addEventListener("click", function (e) {
    e.preventDefault();
    siteheader.classList.add("siteheader--hideannouncement");
    announcementBar.style.marginTop = `-${announcementBar.clientHeight}px`;

    setTimeout(function () {
      siteheader.classList.add("siteheader--closeannouncement");
    }, 2000);

    // Save to sessionStorage
    sessionStorage.setItem("closeannouncement", "true");
  });
};
announcementBarInit();

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

  if ("NodeList" in window && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
      thisArg = thisArg || window;
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  }

/*  ==========================================================================
	FILTERS - OKRE HUB Filtering
	========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = filterPageURL + url_params;

  if (currentPageUrl !== filterPageURL) {
    window.location.href = newUrl;
  }

  if (currentPageUrl === filterPageURL && history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function () {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    filterUpdateURL(filterData, searchData);

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // Scroll to filtering system
      window.scrollTo({
        top: document.querySelector(".filters-pin").offsetTop,
        behavior: "smooth"
      });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        beforeSend: function (xhr) {
          document.querySelector(".filters__apply").textContent = "Filtering...";
        },
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          let showingCounter = 0;

          // if (data.max_page === 1) {
          showingCounter = data.found_posts;
          // } else if (data.max_page > 1) {
          //   showingCounter = data.post_count;
          // }

          document.querySelector(".posts__searchresult").innerText =
            data.post_count === 1 ? `Showing ${showingCounter} result` : `Showing ${showingCounter} results`;

          // change the button label back
          document.querySelector(".filters__apply").textContent = "Apply filter";

          // hide load more button, if there are not enough posts for the second page

          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts();

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");

  if (filterForm && filterForm.length) {
    // Filter on page load only if we are on the /all posts page
    //Check if we are on posts pages or Okre Hub
    if (currentPageUrl === filterPageURL) {
      filterGetPosts();
    }

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    // Setting up event listener to trigger the filter
    // submitBtn.addEventListener("click", function (e) {
    //   // Call the filtering post function
    //   filterGetPosts();
    // 	filters.classList.toggle("filters--dropdownopen");
    // });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      let currentPageUrl = window.location.href.split("?")[0];

      //Check if we are on posts pages or Okre Hub
      if (currentPageUrl !== filterPageURL) {
        let filterData = filterGetFormData();
        let searchData = filterSearchInput.value;

        // Update url
        filterUpdateURL(filterData, searchData);
      } else {
        // Call the filtering post function
        filterGetPosts();
        filters.classList.remove("filters--searchopen");
        filters.classList.remove("filters--dropdownopen");
      }
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      if (filterSearch.classList.contains("filters__search--open")) {
        filterSearch.classList.remove("filters__search--open");
      } else {
        filterSearch.classList.add("filters__search--open");
        filterSearchInput.focus();
      }
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        //   filterGetPosts();
        //   filters.classList.toggle("filters--dropdownopen");

        // Setting the All Content/Subject checkbox functionality
        let groupName = evt.target.name.replace("all_", "");
        if (evt.target.checked) {
          if (evt.target.value !== "all") {
            document.querySelector('input[type="checkbox"][name=all_' + evt.target.name + "]").checked = false;
          } else {
            document
              .querySelectorAll('input[type="checkbox"][name=' + groupName + "]")
              .forEach(el => (el.checked = false));
          }
        } else {
          if (evt.target.value === "all") {
            evt.target.checked = true;
          } else {
            let activeFiltersInGroup = false;
            document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
              if (el.checked === true) {
                activeFiltersInGroup = true;
              }
            });
            if (!activeFiltersInGroup) {
              document.querySelector('input[type="checkbox"][name=all_' + groupName + "]").checked = true;
            }
          }
        }
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();

/*  ==========================================================================
    FILTERING - URL Parameter functions
    ========================================================================== */

/* UPDATE URL PARAMETERS */
// function filter__update_url(filter_data, search_data) {
//   var url_params = "";

//   $.each(filter_data, function (key, value) {
//     if (!$.isEmptyObject(value)) {
//       if (url_params === "") {
//         url_params = url_params + "?";
//       } else {
//         url_params = url_params + "&";
//       }
//       // Convert values to comma seperated string
//       let values = Object.keys(value)
//         .map(function (k) {
//           return value[k];
//         })
//         .join(",");
//       url_params = url_params + "filter_" + key + "=" + values;
//     }
//   });

//   if (search_data) {
//     if (url_params === "") {
//       url_params = url_params + "?";
//     } else {
//       url_params = url_params + "&";
//     }
//     url_params = url_params + "search=" + search_data;
//   }

//   var page_url = window.location.href.split("?")[0];
//   var new_url = page_url + url_params;

//   if (history.pushState) {
//     window.history.pushState({ path: new_url }, "", new_url);
//   }
// }

// // Setup styling classes on new filter
// function filters__update_styling(filter_data) {
//   // Reset styles
//   $(".filters__fieldset").removeClass("filters__fieldset--active");
//   $(".filters__fieldset__field").removeClass("filters__fieldset__field--active");

//   // Reset tags
//   $(".filters__tags").removeClass("filters__tags--active");
//   $(".filters__activetags__tags").html("");

//   $.each(filter_data, function (key, values) {
//     if (!$.isEmptyObject(values)) {
//       let filter_name = key;
//       // Make field group active
//       $(".filters__fieldset[data-value='" + key + "']").addClass("filters__fieldset--active");
//       $.each(values, function (key, value) {
//         // Make input field active
//         let filter_input = $("input[name='" + filter_name + "'][value='" + value + "']").closest(
//           ".filters__fieldset__field"
//         );
//         $(filter_input).addClass("filters__fieldset__field--active");
//         // Show active tags
//         $(".filters__tags").addClass("filters__tags--active");
//         // Add tag
//         let filter_input_name = $(filter_input).find(".filters__fieldset__field__label").html();
//         $(".filters__activetags__tags").append(
//           "<div class='filters__tag' data-name='" +
//             filter_name +
//             "' data-value='" +
//             value +
//             "'>" +
//             filter_input_name +
//             "</div>"
//         );
//       });
//     }
//   });
// }

// function filters__filter_posts() {
//   // Get filters and search passed in to main.js via filters.php
//   let filters = filter_settings.filters;
//   let search = filter_settings.search;

//   let filter_data = filters__get_filter_data($(".filters"), filters);

//   let search_data = false;
//   if (search) {
//     search_data = $(".filters__search input").val();
//   }

//   if (filter_data || search_data) {
//     // Update filter styling and tags
//     filters__update_styling(filter_data);

//     // Update url
//     filters__update_url(filter_data, search_data);

//     // If is initial load and there is active tags on search data then trigger ajax, if not initial load then trigger everytime
//     if (
//       (filters_initial_load && ($(".filters__tags").hasClass("filters__tags--active") || search_data)) ||
//       !filters_initial_load
//     ) {
//       filters_initial_load = false;

//       // Scroll to filtering system
//       $([document.documentElement, document.body]).animate(
//         {
//           scrollTop: $(".filters-pin").offset().top
//         },
//         250
//       );

//       // If there's an active search, open the search field
//       if (search_data) {
//         $(".filters__search").addClass("filters__search--open");
//       }

//       // Start filtering
//       $(".posts-container").addClass("filtering");

//       // Trigger ajax
//       var data = {
//         action: "filter",
//         query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
//         page: php_variables.current_page,
//         filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
//         filter_data: filter_data,
//         search_data: search_data
//       };

//       $.ajax({
//         url: php_variables.ajax_url,
//         data: data, // form data
//         dataType: "json", // this data type allows us to receive objects from the server
//         type: "POST",
//         beforeSend: function (xhr) {
//           $(".filters").find("button").text("Filtering...");
//         },
//         success: function (data) {
//           // when filter applied:
//           // set the current page to 1
//           php_variables.current_page = 1;

//           // set the new query parameters
//           php_variables.posts = data.posts;

//           // set the new max page parameter
//           php_variables.max_page = data.max_page;

//           // change the button label back
//           $(".filters").find("button").text("Apply filter");

//           // insert the posts to the container
//           $(".posts-container").html(data.content);

//           // hide load more button, if there are not enough posts for the second page
//           if (data.max_page < 2) {
//             $(".paging__loadmore").hide();
//           } else {
//             $(".paging__loadmore").show();
//           }

//           // Finish filtering
//           $(".posts-container").removeClass("filtering");
//         },
//         error: function (data) {}
//       });
//     }
//   }
// }

// // Setup an trigger filtering
// let filters_initial_load = true;

// if ($(".filters").length) {
//   // Filter on page load
//   filters__filter_posts();

//   // Filter on submit
//   $(".filters").submit(function (e) {
//     filters__filter_posts();

//     // do not submit the form
//     return false;
//   });

//   // Submit for on checkbox click
//   $(".filters").on("change", "input:checkbox", function () {
//     // Update filtering
//     $(".filters").submit();
//     // Close dropdown
//     $(".filters").removeClass("filters--dropdownopen");
//   });

//   // Dropdown open & close
//   $(".filters__dropdownbtn").click(function () {
//     $(this).closest(".filters").toggleClass("filters--dropdownopen");
//   });

//   // Search open & close
//   $(".filters__search__icon").click(function () {
//     if ($(this).closest(".filters__search").hasClass("filters__search--open")) {
//       $(this).closest(".filters__search").removeClass("filters__search--open");
//     } else {
//       $(this).closest(".filters__search").addClass("filters__search--open");
//       $(this).closest(".filters__search").find("input").focus();
//     }
//   });

//   // Remove tags on click
//   $(".filters__activetags__tags").on("click", ".filters__tag", function () {
//     let filter_name = $(this).data("name");
//     let filter_value = $(this).data("value");
//     // Unselect input checkbox
//     let filter_input = $("input[name='" + filter_name + "'][value='" + filter_value + "']").prop("checked", false);
//     // Remove tag
//     $(this).remove();
//     // Trigger filter
//     filters__filter_posts();
//   });

//   // Clear all
//   $(".filters__clearall").click(function () {
//     // Clear search
//     $(".filters__search").find("input").val("");
//     $(".filters__search").removeClass("filters__search--open");
//     // Remove all tags
//     $(".filters__tags").removeClass("filters__tags--active");
//     $(".filters__activetags__tags").html("");
//     // Uncheck all inputs
//     $(".filters input").prop("checked", false);
//     // Trigger filter
//     filters__filter_posts();
//   });
// }
